var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "greeting" }, [
      _vm._v("Hello " + _vm._s(_vm.name) + _vm._s(_vm.exclamationMarks)),
    ]),
    _vm._v(" "),
    _c("button", { on: { click: _vm.decrement } }, [_vm._v("-")]),
    _vm._v(" "),
    _c("button", { on: { click: _vm.increment } }, [_vm._v("+")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }